import { IconButton } from '@mui/material'
import { MdCheckCircle } from 'react-icons/md'

const IconeQuestionario = ({
  icon: Icon,
  titulo,
  status,
  onClick,
  disabilitado = false,
}) => {
  const renderStatus = () => {
    if (Number.isInteger(status) || status === true) {
      return (
        <MdCheckCircle
          style={{
            position: 'absolute',
            bottom: 0,
            right: 0,
            fontSize: 12,
            color: 'green',
          }}
        />
      )
    }
    return null
  }

  return (
    <div style={{ textAlign: 'center' }}>
      <div style={{ position: 'relative', display: 'inline-block' }}>
        <IconButton onClick={onClick} disabled={disabilitado}>
          <Icon
            size={25}
            color={
              Number.isInteger(status) || status === true
                ? '#2e7d32'
                : '#ff3b3b'
            }
          />
        </IconButton>
        {renderStatus()}
      </div>
      <div style={{ fontSize: 8 }}>{titulo}</div>
    </div>
  )
}

export default IconeQuestionario
